import { Feedback } from '@phpcreation/frontend-components-react';
import Head from 'next/head';
import React from 'react';

type Props = {};

const IndexFeedback = (props: Props) => {
  return (
    <>
      <Head>
        <title>PHPR Ticket Feedback</title>
      </Head>

      <Feedback
        ticketUrl={process.env.NEXT_PUBLIC_TICKET_URL ?? ''}
        feedbackUrl={process.env.NEXT_PUBLIC_FEEDBACK_URL ?? ''}
        fqcn_bui={{
          Bundle: 'ticketClient',
          Unit: 'feedback',
          Interface: 'form',
        }}
      />
    </>
  );
};

export default IndexFeedback;
